import React from 'react';

const ReceiveICPModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Mock ICP principal - in real implementation this would come from user's wallet
  const icpPrincipal = "3y5uj-oyiwp-f5vbw-cxna2-jscer-bcreg-w3q4v-l467g-fs7lc-sou5y-tqe";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(icpPrincipal);
    // You could add a toast notification here
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="receive-icp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Receive Internet Computer</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* QR Code Section */}
          <div className="qr-code-section">
            <div className="qr-code-container">
              {/* Mock QR Code - in real implementation this would be generated from the principal */}
              <div className="qr-code-placeholder">
                <div className="qr-pattern"></div>
                <div className="icp-logo">
                  <span>♾️</span>
                </div>
              </div>
            </div>
          </div>

          {/* Principal Section */}
          <div className="principal-section">
            <div className="principal-label">ICP Principal</div>
            <div className="principal-container">
              <div className="principal-icon">♾️</div>
              <div className="principal-address">{icpPrincipal}</div>
              <button className="copy-button" onClick={copyToClipboard}>
                📋
              </button>
            </div>
            
            {/* Buy ICP Button */}
            <button 
              className="buy-icp-secondary-button"
              onClick={() => {
                // TODO: Implement buy ICP flow or open external link
                window.open('https://coinbase.com/price/internet-computer', '_blank');
              }}
            >
              Buy ICP
            </button>
          </div>
        </div>

        <div className="modal-footer">
          <button className="done-button" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiveICPModal;
